import { Button, Group, Modal, Stack, Text } from '@mantine/core'

interface DisableConfirmModalProps {
  opened: boolean
  title: string
  body: string
  cancelLabel: string
  confirmLabel: string
  onConfirm: () => void
  onCancel: () => void
}

/**
 * Destructive confirmation modal used when the teacher tries to disable an
 * assessment that already has data — either at the item level (affecting N
 * students) or per-student (affecting a single named student).
 *
 * Matches the Harry mocks: title in bold, body text in default color, Cancel
 * with outline-teal style, "Yes, disable" with filled-red destructive style.
 */
export function DisableConfirmModal({
  opened,
  title,
  body,
  cancelLabel,
  confirmLabel,
  onConfirm,
  onCancel,
}: DisableConfirmModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title={title}
      size="sm"
      zIndex={400}
      centered
    >
      <Stack spacing="md">
        <Text size="sm">{body}</Text>
        <Group position="right" spacing="sm">
          <Button variant="outline" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button color="red" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
